import React, { useEffect } from 'react';
import SubmitButton from './SubmitButton';
import { useLocation } from 'react-router-dom';
import {
  CheckCircleIcon,
  HandThumbUpIcon,
  MapPinIcon,
  CurrencyPoundIcon,
} from '@heroicons/react/24/solid';
import { useFlow } from '../utilities/useFlow';

export default function Header(): JSX.Element {
  const { pathname } = useLocation();
  const flow = useFlow();

  useEffect(() => {
    window.fbq('track', 'PageView');
  }, [pathname]);

  return (
    <header className="App-header">
      <nav className="navbar">
        <div className="container">
          {flow === 'Keepr' ? (
            <a href="/" className="navbar-brand keepr-text-logo">
              <img
                src="/img/svg/keepr.svg"
                alt="Keepr Logo"
                className="keepr-svg-logo"
              />
            </a>
          ) : (
            <a href="/" className="navbar-brand">
              <img
                src="/img/Kit Keeper Logo - White.png"
                width="185"
                alt="LOGO"
              />
            </a>
          )}
          <section className="nav-exclude-img">
            <ul id="primary" className="navbar-nav items">
              <li className="menu-item">
                <a
                  href={
                    flow === 'Keepr' ? 'https://keepr.co' : '../storage/boxes'
                  }
                  target="_blank"
                  rel="noreferrer"
                  className={pathname?.includes('storage') ? 'active' : ''}
                >
                  <h5>Storage</h5>
                </a>
              </li>
              {flow !== 'Keepr' && (
                <li className="menu-item">
                  <a
                    href="../shipping/boxes"
                    target="_blank"
                    rel="noreferrer"
                    className={pathname?.includes('suitcase') ? 'active' : ''}
                  >
                    <h5>Shipping</h5>
                  </a>
                </li>
              )}
              {/*<li className="menu-item"><a href="https://www.kitkeeper.co.uk/faqs/">FAQs</a></li>*/}
              {flow !== 'Keepr' && (
                <li className="menu-item">
                  <a
                    href="https://www.kitkeeper.co.uk/blog/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <h5>News</h5>
                  </a>
                </li>
              )}
              <li className="menu-item">
                <a
                  href={
                    flow === 'Keepr'
                      ? 'https://keepr.co/#faqs'
                      : 'https://www.kitkeeper.co.uk/#faqs'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <h5>Support</h5>
                </a>
              </li>
              <li className="menu-item">
                <a href="../login" target="_blank" rel="noreferrer">
                  <h5>
                    <img src="/img/LoginIcon.png" width="25" alt="LOGIN" />
                  </h5>
                </a>
              </li>
            </ul>

            {/*
            <div className="pipe-div">|</div>
            */}
            {/*}   COMMENTING OUT THE SOCIAL MEDIA ICONS IN THE  HEADER BAR
            <ul id="primary" className="navbar-nav icons">

              <li className="social-icons">
                <a href="https://www.facebook.com/kitkeeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-facebook-f" />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.instagram.com/kit.keeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-instagram" />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.linkedin.com/company/kit-keeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-linkedin-in" />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://twitter.com/kit_keeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-twitter" />
                </a>
              </li>

            </ul>
            */}
            {/*<ul className="navbar toggle">*/}
            {/*  <a href="#" className="nav-link pr-sm-4" data-toggle="modal" data-target="#menu">*/}
            {/*    <i className="fas fa-bars" />*/}
            {/*  </a>*/}
            {/*</ul>*/}
            <div className="contact-button">
              <a
                href={
                  flow === 'Keepr'
                    ? 'https://keepr.co/#contact'
                    : 'https://www.kitkeeper.co.uk/contact'
                }
                target="_blank"
                rel="noreferrer"
              >
                <SubmitButton>
                  {/* <i className="fas fa-phone-alt" /> COMMENT OUT THE PHONE ICON IN CONTACT US BUTTON */}
                  <span>Contact Us</span>
                </SubmitButton>
              </a>
            </div>
          </section>
        </div>

        <div className="containerConvincer">
          <div className="convincerContent">
            <span className="ConvincerBar1">
              <CheckCircleIcon className="convincerIcon" />
              Flexible pricing
            </span>

            <span className="ConvincerBar2">
              <HandThumbUpIcon className="convincerIcon" />
              Free £100 cover
            </span>

            <span className="ConvincerBar3">
              <CurrencyPoundIcon className="convincerIcon currencyPoundIcon" />
              <div className="innovateUkWrapper">Funded by InnovateUK</div>
            </span>

            <span className="ConvincerBar5">
              <MapPinIcon className="convincerIcon" />
              Collect & deliver anywhere in the UK
            </span>
          </div>
        </div>
      </nav>
    </header>
  );
}
